export class ActionRequestEntity<
  InputValue extends Object = {},
  ComparedValue extends Object = {}
> {
  path!: string;
  inputValue?: InputValue;
  comparedValue?: ComparedValue;
  keysToAvoid?: string[];
  allValToString?: boolean;

  constructor(data?: Partial<ActionRequestEntity<InputValue, ComparedValue>>) {
    if (!data) return;

    this.path = data.path as string;
    this.inputValue = data?.inputValue;
    this.comparedValue = data?.comparedValue;
    this.keysToAvoid = data.keysToAvoid;
    this.allValToString = data?.allValToString;
  }
}
